import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { Avatar } from "@/components/common";
import { ConnectButton } from "@/components/ConnectButton";

export function SuggestedConnections() {
  const [people, setPeople] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/matches").then((r) => setPeople((r.data.matches || []).slice(0, 3)))
      .catch(() => {}).finally(() => setLoaded(true));
  }, []);

  if (!loaded || people.length === 0) return null;

  return (
    <div className="border border-border bg-card rounded-xl p-5" data-testid="suggested-connections">
      <div className="flex items-center justify-between mb-4">
        <div className="eyebrow text-cobalt flex items-center gap-1.5"><Sparkles size={13} /> People you should meet</div>
        <Link to="/matches" className="text-xs font-semibold text-cobalt hover:underline inline-flex items-center gap-1">
          See all <ArrowRight size={12} />
        </Link>
      </div>
      <div className="grid sm:grid-cols-3 gap-3">
        {people.map((m) => {
          const first = m.name.split(" ")[0];
          const suggested = m.reasons?.[0]
            ? `Hi ${first} — ${m.reasons[0].toLowerCase().startsWith("can help") ? "I'd love to learn from you" : "would love to connect"}. Let's connect on Ikigora!`
            : `Hi ${first} — would love to connect on Ikigora!`;
          return (
            <div key={m.user_id} className="border border-border rounded-lg p-4 flex flex-col items-center text-center" data-testid={`suggested-${m.user_id}`}>
              <Link to={`/members/${m.user_id}`}><Avatar src={m.picture} name={m.name} size={48} className="border" /></Link>
              <Link to={`/members/${m.user_id}`} className="mt-2 text-sm font-semibold hover:text-cobalt transition-colors truncate max-w-full">{m.name}</Link>
              <div className="text-xs text-muted-foreground truncate max-w-full">{(m.role?.length ? m.role.join(", ") : "") || m.title || "Member"}</div>
              {m.reasons?.[0] && <div className="mt-1.5 text-[11px] text-cobalt bg-secondary rounded-full px-2 py-0.5 truncate max-w-full">{m.reasons[0]}</div>}
              <div className="mt-3"><ConnectButton userId={m.user_id} name={m.name} suggestedNote={suggested} size="sm" /></div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
